import { useEffect, useState } from 'react'

import { notifications } from './store'
import type { NotificationItem } from './types'

export type UseNotificationsResult = {
  /** Текущий стек — используется NotificationList. */
  items: NotificationItem[]
  show: typeof notifications.show
  success: typeof notifications.success
  error: typeof notifications.error
  warning: typeof notifications.warning
  info: typeof notifications.info
}

/**
 * React-доступ к стеку уведомлений: реактивный список (для NotificationList) плюс те же
 * императивные методы, что у `notifications`, — чтобы в компонентах не тянуть отдельно
 * прямой импорт стора. Вне React показывать уведомления можно и без хука — напрямую
 * через `notifications.show/success/error/warning/info`.
 */
export function useNotifications(): UseNotificationsResult {
  const [items, setItems] = useState<NotificationItem[]>(() => notifications.getItems())

  useEffect(() => notifications.subscribe(() => setItems(notifications.getItems())), [])

  return {
    items,
    show: notifications.show,
    success: notifications.success,
    error: notifications.error,
    warning: notifications.warning,
    info: notifications.info,
  }
}
